// extracted by mini-css-extract-plugin
export default {"LoginPortal":"LoginPortal_LoginPortal__Fyk9F","LoginPortal_content":"LoginPortal_LoginPortal_content__oJqte","LoginPortal_logos":"LoginPortal_LoginPortal_logos__wjPra"};